import Slider from '../ui/Slider';
import { SCALE_LABELS } from '../../constants/defaults';
import './WizardStep.css';

export default function StepScales({ formData, errors, onChange }) {
  const { scales } = formData;

  const handleChange = (field, value) => {
    onChange('scales', field, value);
  };

  return (
    <div className="wizard-step">
      <div className="wizard-step__header">
        <h2 className="wizard-step__title">Fine-tune the feel</h2>
        <p className="wizard-step__description">
          Adjust these scales to dial in the exact vibe you're looking for.
        </p>
      </div>

      <div className="wizard-step__content">
        <Slider
          label="Layout Density"
          labelLow={SCALE_LABELS.minimalistDense.low}
          labelHigh={SCALE_LABELS.minimalistDense.high}
          value={scales.minimalistDense}
          onChange={(value) => handleChange('minimalistDense', value)}
        />

        <Slider
          label="Tone"
          labelLow={SCALE_LABELS.playfulSerious.low}
          labelHigh={SCALE_LABELS.playfulSerious.high}
          value={scales.playfulSerious}
          onChange={(value) => handleChange('playfulSerious', value)}
        />

        <Slider
          label="Design Approach"
          labelLow={SCALE_LABELS.safeExperimental.low}
          labelHigh={SCALE_LABELS.safeExperimental.high}
          value={scales.safeExperimental}
          onChange={(value) => handleChange('safeExperimental', value)}
        />
      </div>
    </div>
  );
}
